export const WHATSAPP_URL =
  "https://wa.me/393913475965?text=Ciao!%20Vorrei%20un%20preventivo%20per%20le%20carte%20NFC%20e%20QR%20di%20TapGoogle.com%20per%20le%20recensioni%20Google.";

export const WHATSAPP_NUMBER = "+39 391 347 5965";

export const IMAGES = {
  cards:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_e9fc40c1-c70c-44b3-ba93-27952ccdcaee/artifacts/ffa0152336b6be49_Screenshot_20261014_170636_AliExpress.jpg",
  tapDemo:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_e9fc40c1-c70c-44b3-ba93-27952ccdcaee/artifacts/d5a323a1aa1980c2_Screenshot_20261014_170522_AliExpress.jpg",
  stand:
    "https://customer-assets-lxgj4vgw.emergentagent.net/job_e9fc40c1-c70c-44b3-ba93-27952ccdcaee/artifacts/62f738edcc9d5ca6_Screenshot_20261014_170712_AliExpress.jpg",
};

export const scrollToSection = (hash) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(hash, { offset: -72, duration: 1.4 });
  } else {
    document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
  }
};
